module.exports = __webpack_public_path__ + "static/media/remove-icon.848c50ed.svg";